export const splitArrayToTwoChunks = <T>(array: T[], sizeOfFirstChunk: number): { first: T[]; rest: T[] } => {
	const arrayCopy = [...array];

	const first: T[] = [];
	let rest: T[] = [];

	for (let index = 0; index < arrayCopy.length; index++) {
		if (index < sizeOfFirstChunk) {
			first.push(arrayCopy[index]);
		} else {
			rest = arrayCopy.slice(sizeOfFirstChunk);
		}
	}

	return { first, rest };
};
